<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 减重小程序端-我的减重故事
-->

<template>
  <div class="page-main">
    <div class="tip">
      长按分享或保存图片
    </div>
    <div class="report-dialog">
      <div v-if="!url" class="page-content" id="reportCon">
        <div class="page-title">我的减重故事</div>
        <div class="userinfo-box">
          <div class="user-box">
            <img class="user-avatar" :src="user_img" />
            <div class="user-name">{{ userName }}</div>
          </div>
          <div class="data-table">
            <div class="tr th">
              <div class="td-1"></div>
              <div class="td-2">减重前</div>
              <div class="td-2">减重后</div>
            </div>
            <div class="tr">
              <div class="td one-td">服务时间</div>
              <div class="td two-td">{{ firstTime }}</div>
              <div class="td three-td">{{ lastTime }}</div>
            </div>
            <div class="tr">
              <div class="td one-td">体重 (kg)</div>
              <div class="td two-td">{{ firstWeight }}</div>
              <div class="td three-td">{{ lastWeight }}</div>
            </div>
            <div class="tr">
              <div class="td one-td">腰围 (cm)</div>
              <div class="td two-td">{{ firstWaistline }}</div>
              <div class="td three-td">{{ lastWaistline }}</div>
            </div>
            <div class="tr">
              <div class="td one-td">内脏脂肪</div>
              <div class="td two-td">{{ firstViscus ||' ' }}</div>
              <div class="td three-td">{{ lastViscus ||' ' }}</div>
            </div>
            <div class="tr">
              <div class="td one-td">对比照片</div>
              <img class="photo" :src="recordInfo.firstUrl" />
              <img class="photo" :src="recordInfo.lastUrl" />
            </div>
          </div>
        </div>
        <div class="share-card">
          <div class="text">每一次减重的努力，都是为了更好的自己。你拥有无比的潜力，只需要去释放。</div>
          <img class="qrcode"
            src="https://pinghu-blood.oss-accelerate.aliyuncs.com/loss_image/1856252607117033473gh_c53fca4ed1dc_258.jpg?Expires=947811400084&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=qagpc7cscQXBJ9TNu8%2BMUgUIjqo%3D" />
        </div>
      </div>
      <div v-else class="img-box">
        <img :src="url" />
      </div>
      <!-- <div class="btn-footer">
        <div class="btn" @click="saveImg">
          保存到相册并分享
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { htmlToPDF } from "../utils/html2pdf";
import user_img from '../assets/images/user.png';

export default {
  data() {
    return {
      user_img,
      userName: "",
      recordInfo: {},
      url: '',
      firstTime:'',
      lastTime:'',
      firstWeight:'',
      lastWeight:'',
      firstWaistline:'',
      lastWaistline:'',
      firstViscus:'',
      lastViscus:'',
    };
  },
  mounted() {
    document.title = '我的减重故事'
    this.id = getQueryString('id');
    let name=getQueryString('name',true);
    this.userName= decodeURI(name);
    this.firstTime=getQueryString('firstTime');
    this.lastTime=getQueryString('lastTime')
    this.firstWeight=getQueryString('firstWeight')
    this.lastWeight=getQueryString('lastWeight')
    this.firstWaistline=getQueryString('firstWaistline')
    this.lastWaistline=getQueryString('lastWaistline')
    this.firstViscus=decodeURI(getQueryString('firstViscus',true) || '')
    this.lastViscus=decodeURI(getQueryString('lastViscus',true) || '')
    this.getRecordInfo();
  },

  methods: {

    getRecordInfo() {
      ajax
        .Post({
          url: '/api/loss/punch/selectPatientInfo',
          data: { id: this.id }
        }).then(({ data: { success, data } }) => {
          if (success) {
            this.recordInfo = {...data}
            setTimeout(() => {
             this.saveImg()
            }, 200);
          }
        })
    },
    saveImg() {
      htmlToPDF('reportCon', '月报').then(url => {
        this.url = url
      });
    },

  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}
.page-main{
  padding: 20px 10px;
  background-color: #eaedf2;
}
/* 页面下载内容 */
.report-dialog {
  position: relative;
  min-height: 100vh;
  height: auto;
  /* overflow: auto; */
  padding-bottom: 90px;
  /* background-color: #FBB13D; */
}

.report-dialog {
  width: 100%;
  height: auto;
  /* overflow: auto; */
  /* background-color: #FEDDB5; */
  /* padding-bottom: 40px; */
}

.page-content {
  width: 100%;
  height: auto;
  background-color: #FEDDB5;
  padding: 16px;

}

.page-content .page-title {
  height: 58px;
  line-height: 58px;
  text-align: center;
  color: #333;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

.page-content .userinfo-box {
  width: 100%;
  height: auto;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 10px 16px 16px;
  margin-bottom: 14px;
}

.page-content .user-box {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
}

.page-content .user-box .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.page-content .user-box .user-name {
  font-size: 18px;
  color: #333333;
}

.data-table {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.data-table .th {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

.data-table .th .td-1 {
  width: 52px;
}

.data-table .th .td-2 {
  flex: 1;
  text-align: left;
}

.data-table .tr {
  height: 36px;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.data-table .tr .td {
  text-align: left;
}

.data-table .tr .td.one-td {
  width: 52px;
  font-size: 12px;
  padding-right: 4px;
  color: #666666;
}

.data-table .tr .td.two-td {
  flex: 1;
  line-height: 36px;
  height: 36px;
  padding-left: 8px;
  font-weight: 500;
  background-color: #FFF4E6;
  color: #FBB13D;
  border-radius: 4px;
}

.data-table .tr .td.three-td {
  flex: 1;
  line-height: 36px;
  height: 36px;
  padding-left: 8px;
  font-weight: 500;
  background-color: #F4FFF8;
  color: #10C673;
}

.data-table .tr td:first-child {
  width: 52px;
}

.data-table .photo {
  flex: 1;
  width: 104px;
  max-width: 100%;
  /* min-height: 120px; */
  height: auto;
}

.share-card {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #333;
  padding: 12px 16px;
  background: #FFFFFF;
  border-radius: 8px;

}

.share-card .text {
  flex: 1;
}

.share-card .qrcode {
  width: 48px;
  height: 48px;
}

/* 底部按钮 */
.btn-footer {
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  height: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  padding-bottom: 27px;
}

.btn {
  width: 343px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  letter-spacing: 1px;
  background: #FBB13D;
  border-radius: 24px;
}

.history-loading {
  width: 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
}

.img-box {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0
}

.img-box img {
  width: 100%;
  height: auto;
}

.tip {
  color: #777;
  color: #FE5B59;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  padding-bottom: 20px;
}
</style>
